<template>
  <!-- 盒子管理-保低配置-水池配置 -->
  <div v-if="$route.query.pv" class="case_guaranteed_pool_config-box">
    <!-- header头部 -->
    <header></header>
    <!-- body内容 -->
    <div class="body-box">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="注水金额">
          <el-input
            v-model="formData.water"
            placeholder="请输入注水金额"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">现在注水</el-button>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>
      <h1>自动注水</h1>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="自动注水时间">
          <el-date-picker
            style="width: 200px"
            v-model="formDataAutomatic.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          -
          <el-date-picker
            style="width: 200px"
            v-model="formDataAutomatic.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="自动注水金额">
          <el-input
            v-model="formDataAutomatic.amount"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-right: 100px">
          <el-switch
            v-model="formDataAutomatic.enable"
            :active-value="1"
            :inactive-value="0"
            active-text="打开自动注水"
            inactive-text="关闭自动注水"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit1">保存</el-button>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>
      <h1>注水列表</h1>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          -
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData2">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData2">刷新</el-button>
        </el-form-item>
        <el-form-item>
          <h2>今日剩余数量：{{ remain_water }}</h2>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="created_at" label="注水时间" align="center">
        </el-table-column>
        <el-table-column prop="water" label="注水量" align="center">
        </el-table-column>
        <el-table-column prop="type" label="注水方式" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">自动</span>
            <span v-else>手动</span>
          </template>
        </el-table-column>
        <el-table-column prop="consume_time" label="消耗完时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1,
        start_time: '',
        end_time: ''
      },
      formData: {
        water: ''
      },
      formDataAutomatic: {
        amount: '',
        enable: '',
        time_range: {
          end_time: '',
          start_time: '',
        }
      },
      remain_water: '',//剩余注水量
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData1()
    this.getData2()
  },
  methods: {
    submit() {
      //保存新用户配置
      if (!this.formData.water || this.formData.water < 0) {
        this.$message.error("注水量必须大于0")
        return
      }
      let params = this.formData
      patchApiData('water_injection', params).then(res => {
        this.$message.success("保存成功！")
        this.getData2()//刷新
      })
    },
    getData1() {
      //获取自动注水配置
      let params = { key: 'bottom_create_m9_profit' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          this.formDataAutomatic = res
        }
      }).finally(() => {
      })
    },
    submit1() {
      //保存新用户配置
      let params = {
        key: 'bottom_create_m9_profit',
        val: this.formDataAutomatic
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success("保存成功！")
        this.getData1()//刷新
      })
    },
    getData2() {
      //获取注水列表
      this.loading = true
      let params = this.query
      getApiData('water_record', params).then(res => {
        if (res) {
          this.remain_water = res.remain_water
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    }

  }

}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    width: 800px;
  }
}
</style>